<template>
  <div>
    <Header></Header>
    <div class="main">
        <!-- 产品主页 -->
        <product v-if="id==2"></product>
        <!-- 支持与服务主页 -->
        <service v-if="id==3"></service>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
    import Header from '../../components/common/header.vue'
    import Product from './product/product.vue'
    import Service from './service/service.vue'
    import Footer from '../../components/common/footer.vue'
    export default {
        data() {
            return {
                id: 0,
            }
        },
        components: {
            Header,
            Product,
            Service,
            Footer
        },
        watch: {
            '$route' (to, from) {
                this.getId()
            }
        },
        created() {
            this.getId();
        },
        methods: {
            getId() {
                this.id = window.location.href.substr(window.location.href.length - 1);
            },
        },
    }
</script>
<style lang="scss" scoped="scoped">
    .main {
        margin-top: 80px;
    }
</style>